import { gql } from 'apollo-angular';

export class RangeProductQueries {
    static RANGEPRODUCTS = gql`
        query getRangeProducts(
            $where: MarketplaceRangeProductSearchFilterInput
            $pagination: PaginationInput
        ) {
            marketplaceRangeProductSearch(
                where: $where
                pagination: $pagination
            ) {
                totalCount
                items {
                    id
                    operator {
                        id
                        countryId
                        name
                    }
                    provider {
                        id
                        name
                    }
                    productId
                    serviceCategory
                    productCategory
                    productSubCategory
                    providerId
                    title
                    maxAmount {
                        amount
                        currency
                        formatted
                    }
                    minAmount {
                        amount
                        currency
                        formatted
                    }
                    operatorId
                    countryId
                    destinationType
                }
            }
        }
    `;

    static VALIDATERANGEPRODUCT = gql`
        query validateRangeProduct(
            $input: MarketplaceRangeProductValidateInput!
        ) {
            marketplaceRangeProductValidate(input: $input) {
                productReference
                valueCurrencyId
                valueAmount
                priceCurrencyId
                priceAmount
                costCurrencyId
                costAmount
            }
        }
    `;
}
export class RangeProductMutations {
    static CREATERANGEPRODUCT = gql`
        mutation createRangeProduct(
            $input: MarketplaceRangeProductCreateInput!
        ) {
            marketplaceRangeProductCreate(input: $input) {
                id
                # product {
                #     id
                #     enabled
                #     titleContentKey
                #     descriptionContentKey
                #     priority
                #     serviceCategory
                #     productCategory
                #     productSubCategory
                #     title
                #     provider {
                #         name
                #     }
                #     productReference
                #     price {
                #         amount
                #         currency
                #     }
                #     cost {
                #         amount
                #         currency
                #     }
                #     description
                #     countryId
                #     operator {
                #         name
                #     }
                # }
            }
        }
    `;
}
